export function Loader() {
  return (
    <section className="h-[100dvh] w-screen flex items-center justify-center">
      <div className="spinner size-10 !border-4 !border-primary" />
    </section>
  );
}
